import { getFollowPreferences } from '@gonfalon/openapi/operations/getFollowPreferences';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const followPreferences = createQueryKeys('followPreferences', {
  detail: {
    queryKey: null,
    queryFn: async ({ signal }) => reactQueryResponseAdapter(getFollowPreferences({}, { signal })),
  },
});
